import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  ContentSwitcher: {
    position: 'relative',
    width: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    minHeight: 60,
    '&__tabs': {
      padding: 'initial',
      '&__button': {
        backgroundColor: '#06B6D4',
        '&--width': {
          width: '50% !important',
        },
      },
      '&__wrapper': {
        color: theme.palette.white,
      },
    },
    '&__table': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      '&--display': {
        display: 'none',
      },
    },
  },
}));

export { useStyles };
